// import { Link } from 'react-router-dom'
import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { set_page_refresh } from "../../redux/action";


const EditCategoryList = () => {
    const l = useSelector((state) => state.language || "en");
    const t = useSelector((state) => state.translation || "en");
    const dispatch = useDispatch();
  const data = useSelector((state) => state.category_edit);
  const [category, setCategory] = useState({})
  const closeRef = useRef(null);

  useEffect(() => {
    console.log(category, data)
    if(data) {
      const { _id, name, userId, status, createdBy, createdAt }  = data;
      setCategory( { _id, name, userId, status, createdBy, createdAt } )
    }
  }, [data])
  
  const submit= async (event) => {
    const form = event.currentTarget;
    
    event.preventDefault()
    event.stopPropagation()
    try {
      if(form?.checkValidity()) {
        let result = await axios.post("addcategory/", category);
        closeRef.current?.click()
        document.querySelector(".modal-backdrop").classList.toggle("show")
        dispatch(set_page_refresh("categorylist"))
        console.log(result)
      }
    } catch(e) {
      console.log(e)
      return false;
    }
    

    return false;
  }
  const handleInputChange = (e) => {
    console.log(e)
    const { name, value } = e.target;
    setCategory(prevState => ({
      ...prevState,
      [name]: value
    }));
  };
    return (
        <div>
            {/* Edit Category */}
            <div className="modal fade" id="edit-category">
                <div className="modal-dialog modal-dialog-centered custom-modal-two">
                    <div className="modal-content">
                        <div className="page-wrapper-new p-0">
                            <div className="content">
                                <div className="modal-header border-0 custom-modal-header">
                                    <div className="page-title">
                                        <h4>{t?.[l]?.["edit_category"] || "Edit Category"}</h4>
                                    </div>
                                    <button
                                        type="button"
                                        className="close"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                    >
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className="modal-body custom-modal-body">
                                    <form onSubmit={submit}>
                                        <div className="mb-3">
                                            <label className="form-label">{t?.[l]?.["category"] || "Category"}</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                defaultValue="Laptop"
                                                value={category.name} required name="name" onChange={handleInputChange}
                                            />
                                        </div>
                                        {/* <div className="mb-3">
                                            <label className="form-label">Category Slug</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                defaultValue="laptop"
                                            />
                                        </div> */}
                                        {/* <div className="mb-0">
                                            <div className="status-toggle modal-status d-flex justify-content-between align-items-center">
                                                <span className="status-label">Status</span>
                                                <input
                                                    type="checkbox"
                                                    id="user3"
                                                    className="check"
                                                    defaultChecked="true"
                                                />
                                                <label htmlFor="user3" className="checktoggle" />
                                            </div>
                                        </div> */}
                                        <div className="modal-footer-btn">
                                            <button
                                                type="button"
                                                className="btn btn-cancel me-2"
                                                data-bs-dismiss="modal"
                                                ref={closeRef}
                                            >
                                                {t?.[l]?.["cancel"] || "Cancel"}
                                            </button>
                                            
                                            <button type="submit" className="btn btn-submit">
                                                {t?.[l]?.["save"] || "Save"}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* /Edit Category */}
        </div>
    )
}

export default EditCategoryList
